import { Box, Button, Typography, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Autocomplete } from "@mui/material"
import { useEffect, useState } from "react"

export const Modal = (props: any) => {

    const [value, setValue] = useState<any>({});

    const updateKey = (key: string, value: any) => {
        setValue(Object.assign({}, value, { [key]: value }))
    }

    useEffect(() => {
        setValue({ ...props.selected })
    }, [props.selected])

    const submit = () => {
        props.onSubmit?.(value)
    }

    const renderList = (field, value: any, onChange?: (value: any) => void) => {

        let list = (value || []).slice();

        const addItem = () => {
            list.push({})
            
            onChange?.( list )
        }

        const updateItem = (ix, item: any, value: any) => {
            list[ix][item.name] = value;
            onChange?.( list )
        }

        return (
            <Box>
                <Typography>{field.name}</Typography>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px'
                }}>
                    {list.map((listItem, ix) => 
                        <Box key={ix} sx={{display: 'flex'}}>
                        {field.type?.ofType?.inputFields?.map((item, ox) => (
                            <Box sx={{flex: 1}} key={ox}>
                                {renderField(item, listItem[item.name], (value) => {
                                    updateItem(ix, item, value)
                                })}
                            </Box>
                        ))}
                        </Box>
                    )}
                </Box>
                <Button onClick={addItem} fullWidth>Add</Button>
            </Box>
        )
    }

    const renderScalar = (field, value: any, onChange?: (value: any) => void) => {
        switch(field.type.name){
            case 'Float':
            case 'Int':
                return (
                    <TextField 
                    value={value || ''}
                    type="number"
                    onChange={(e) => onChange(parseFloat(e.target.value))}
                    fullWidth 
                    size="small" 
                    label={field?.name} />
                )
            default:
                return (
                    <TextField 
                        disabled={field.type?.name == 'ID'}
                        value={value || ''}
                        onChange={(e) => onChange(e.target.value)}
                        fullWidth 
                        size="small" 
                        label={field?.name} />
                )
        }
 
    }

    const renderEnum = (field, value: any, onChange?: (value: any) => void) => {
        return <Autocomplete 
                fullWidth
                value={value || ''}
                onChange={(e, value) => onChange(value)}
                options={field?.type?.enumValues?.map((x) => x.name)}
                renderInput={(params) => <TextField {...params} size="small" label={field?.name} />} />
    }

    const renderInputObject = (field: any, value: any, onChange?: (value: any) => void) => {

        const data = props.fetchData?.[field.type?.name?.replace(/Input$/, 's')];

        const stripHidden = (value: any) => {
            return Object.keys(value).filter((a) => a.indexOf('__') < 0).reduce((prev, curr) => ({...prev, [curr]: value[curr]}), {})
        }

        return <Autocomplete
                fullWidth
                value={value || ''}
                onChange={(e, value) => onChange(stripHidden(value))}
                options={data || []}
                getOptionLabel={(option) => typeof(option) == 'string' ? option : (option.name || JSON.stringify(option)) }
                renderInput={(params) => <TextField {...params} size="small" label={field?.name} />} />
    }
  

    const renderField = (field, value: any, onChange?: (value: any) => void) => {
        switch(field.type.kind){
            case 'LIST':
                return renderList(field, value, onChange);
            case 'SCALAR':
                return renderScalar(field, value, onChange);
            case 'ENUM':
                return renderEnum(field, value, onChange)
            case 'INPUT_OBJECT':
                return renderInputObject(field, value, onChange)
        }
        // if(Array.isArray(field.type)){
        //     const fieldUi = (<Box sx={{display: 'flex'}}>
        //         {Object.keys(field.type?.[0]).map((key, ix) => <Box key={`array-field-${ix}`}>
        //             {renderField({key, type: field.type?.[0]?.[key]})}
        //             </Box>
        //         )}
        //     </Box>);
        //     return (
        //         <Box>
        //             <Typography fontWeight="bold">{field.key}</Typography>
        //             <Box sx={{
        //                 display: 'flex',
        //                 gap: '8px',
        //                 flexDirection: 'column'
        //             }}>
        //             {fieldUi}
        //             </Box>
        //             <Button>Add {field.key}</Button>
        //         </Box>
        //     )
        // }

        // switch (field.type) {
        //     default:
        //         return (
        //             <TextField
        //                 value={value[field.key] || ""}
        //                 onChange={(e) => updateKey(field.key, e.target.value)}
        //                 fullWidth
        //                 size="small"
        //                 label={field.key} />
        //         )
        // }
        return null;
    }
    return (
        <Dialog
            fullWidth
            open={props.open}
            onClose={props.onClose}>
            <DialogTitle>{props.selected?.id ? "Update" : "Create"} {props.model?.name}</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', paddingTop: '8px' }}>
                    {props.inputFields?.map((field, ix) => (
                        <Box key={ix}>
                            {renderField(field, value[field.name], (values) => setValue({...value, [field.name]: values}))}
                        </Box>
                    ))}
                </Box>
            </DialogContent>
            <DialogActions sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: props.selected?.id ? 'space-between' : 'flex-end'
            }}>
                {props.selected?.id ? <Button variant='contained' onClick={props.onDelete} color="error">Delete</Button> : null}
                <Box sx={{ display: 'flex' }}>
                    <Button onClick={props.onClose}>Cancel</Button>
                    <Button onClick={submit} variant="contained">{props.selected?.id ? "Save" : "Create"}</Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}